import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Config from 'Config';

const ZENDESK_SRC = Config.Environment.ZENDESK_SRC_URL;

/** Used to load the Zendesk chat script into the document head via Helmet */
export default function Zendesk({ token }: ZendeskWidgetProps) {
  const [scriptLoaded, setScriptLoaded] = useState<boolean>(
    typeof (window as any)?.zE === 'function'
  );

  // Register Zendesk event handlers
  useEffect(() => {
    if (typeof (window as any)?.zE === 'function') {
      (window as any)?.zE('messenger', 'loginUser', sendUserToken);
      (window as any)?.zE('messenger:on', 'unreadMessages', handleUnreadMessages);
      (window as any)?.zE('messenger', 'hide');

      (window as any)?.zE('messenger:on', 'close', handleClose);
    }
  }, [scriptLoaded]);

  function sendUserToken(callback: (arg0: string) => void) {
    callback(String(token));
  }

  function handleClose() {
    (window as any).zE('messenger', 'close');
    (window as any).zE('messenger', 'hide');
  }

  function handleUnreadMessages(unreadMessageCount: number) {
    // Force the chat window open when a new message is received from the agent
    //
    // Although this may not be perfect UX - it prevents the end user from losing
    // the chat window since we are hiding the default launcher
    if (unreadMessageCount > 0) {
      (window as any).zE('messenger', 'open');
    }
  }

  function handleChangeClientState(_: any, addedTags: Tags) {
    if (addedTags?.scriptTags?.length) {
      const foundScript = addedTags.scriptTags.find(
        (attributes) => attributes?.src === ZENDESK_SRC
      );
      if (foundScript) {
        foundScript.addEventListener('load', () => setScriptLoaded(true), { once: true });
      }
    }
  }

  return (
    // onChangeClientState lets us known when a helmet managed script has been added to the dom
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    <Helmet onChangeClientState={handleChangeClientState}>
      <script id="ze-snippet" src={ZENDESK_SRC} />
    </Helmet>
  );
}

export function openWidget() {
  if (typeof (window as any)?.zE === 'function') {
    (window as any).zE('messenger', 'show');
    (window as any).zE('messenger', 'open');
  }
}

type ZendeskWidgetProps = {
  token: string | null | undefined;
};

type Tags = {
  scriptTags: HTMLScriptElement[];
};
